/**
 *
 * @description 上报banner点击
 */
export function reportClickBanner(params: {
    /** 运营位入口 */
    banner_entrance?: string

    /** 运营位名称, 例如 顶部banner */
    banner_title?: string

    /** 运营位id */
    banner_id: string

    /** 轮播图序号 */
    banner_rank: number
}) {
    window['sensors'].track('BannerClick', Object.assign({ banner_entrance: '活动', banner_title: '顶部banner' }, params))
}

/**
 *
 * @description 上报活动点击事件
 */
export function reportActivityClick(params: {
    /** 活动id */
    activity_id: string

    /** 活动状态 例如 activity_status */
    activity_status: string

    /** 抽奖，答题，投票，政治 */
    activity_type?: string

    /** 发布者id */
    anthor_id?: string

    /** 发布者名称 */
    anthor_name?: string

    /** 发布者类型 例如 记者、编辑 */
    anthor_type?: string

    /** 发布者所属平台 例如 91.8、其他电视台 */
    anthor_platform?: string

    /** 发布日期(毫秒) */
    public_time?: number

    /** 所在页面 */
    current_page?: string

    /** 所属tab */
    tab_id: string

    /** 活动名称 */
    activity_name: string
}) {
    window['sensors'].track('ActivityClick', Object.assign({ activity_type: '活动' }, params))
}
